<template>
  <aside class="side-bar">
    <router-link
      :to="{name: 'dashboard'}"
      exact
      class="q-pa-md block link">
      <q-icon name="fa fa-tachometer-alt" class="q-mr-sm"/> Dashboard
    </router-link>
    <div class="q-px-md">
      <user-client-list :user-id="userId" starred />
      <q-separator class="q-my-md" />
      <user-client-list :user-id="userId" subscribe />
    </div>
  </aside>
</template>

<style lang="scss">
  @import '../styles/quasar.variables.scss';

  .side-bar {
    a {
      text-decoration: none;
      color: $grey-10;
      &:hover, &.router-link-active {
        background: $secondary;
        cursor: pointer;
      }
    }
  }
</style>

<script>
import recognition from '@/auth/recognition';
import UserClientList from '../user-client/UserClientList.vue';

export default {
  components: { UserClientList },
  data() {
    return {
      userId: recognition.getUserId(),
    };
  },
};
</script>
